var _defs, _polygon, _polygon2, _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictograms",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#970a82;}.cls-2,.cls-3,.cls-4{fill:#f0ab00;}.cls-2{opacity:0.4;}.cls-3{opacity:0.7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "281022-pictogram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210 182 30 182 30 58 120 120 210 58 210 182"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "210 120 30 120 30 89 75 89 120 120 165 89 210 89 210 120"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30,
    y: 120,
    width: 180,
    height: 31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30,
    y: 151,
    width: 180,
    height: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212,184H28V56H212ZM32,180H208V60H32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.407b4e11115a66a9d0f1a32c6c5ab95e.svg";
export { ForwardRef as ReactComponent };